import { export_json_to_excel } from '../utils/excel/Export2Excel.js'
// export const uploadUrl = 'http://192.168.110.48:8106'
// export const uploadUrl = 'http://192.168.110.201:8200'
export const uploadUrl = 'https://dev.admin.api.fxzb.vip'
// export const uploadUrl = 'https://admin.api.fxzb.vip'
export const appid = 'wx43df1f6953007bd7'  //龙猫 测试
// export const appid = 'wx5595a716fb7b257f'  //发现周边 线上

// export const miniUrl = 'http://192.168.110.48:8106'
// export const miniUrl = 'http://192.168.110.201:8081'
export const miniUrl = 'https://dev.api.fxzb.vip'
// export const miniUrl = 'https://api.fxzb.vip'

//京东商家id
// 线上
// export const JdKeeperId = 'ff8080818c170b3d018c3ae778285f91'
// dev环境
export const JdKeeperId = 'ff8080818bd8d452018bd92cc9470027'
// 本地环境
// export const JdKeeperId = '2c9082718be19cab018be1e95dd50042'

// 线上
// export const classValue = 'CheckCode_class-UdLeYL'
// dev环境
export const classValue = 'CheckCode_class-hdk0eR'
// 本地
// export const classValue = 'CheckCode_class-zn4feA'
export function currentUrlToParams(key = null) {
  const paramsUrl = (window.location.href).split('?')
  if (paramsUrl.length < 2) return key ? null : {}
  const paramsArr = paramsUrl[1].split('&')
  const paramsData = {}
  paramsArr.forEach(r => {
    const data = r.split('=')
    paramsData[data[0]] = data[1]
  })
  if (key) return paramsData.hasOwnProperty(key) ? paramsData[key] : null
  return paramsData
}

export function clone(obj) {
  const strData = JSON.stringify(obj)
  return JSON.parse(strData)
}

export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

// 数组深拷贝
export function copy(obj) {
  const newObj = obj.constructor === Array ? [] : {}
  if (typeof obj !== 'object') {
    return
  }
  for (const i in obj) {
    newObj[i] = typeof obj[i] === 'object' ? copy(obj[i]) : obj[i]
  }
  return newObj
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

export function numberFormat(number, decimals, dec_point, thousands_sep) {
  /*
     * 参数说明：
     * number：要格式化的数字
     * decimals：保留几位小数
     * dec_point：小数点符号
     * thousands_sep：千分位符号
     * */
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  var n = !isFinite(+number) ? 0 : +number
  var prec = !isFinite(+decimals) ? 2 : Math.abs(decimals)
  var sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep
  var dec = (typeof dec_point === 'undefined') ? '.' : dec_point
  var s = ''
  var toFixedFix = function (n, prec) {
    var k = Math.pow(10, prec)
    return '' + Math.ceil(n * k) / k
  }

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  var re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}
// 时间戳转换方法    date:时间戳数字
export function format_redDate(date) {
  var date = new Date(date)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  // + ss
  return YY + MM + DD + ' ' + hh + mm + ss
}
// 时间戳转换方法    date:时间戳数字
export function format_datestr(date) {
  var date = new Date(date)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
  // var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  // + ss
  return YY + MM + DD + ' ' + hh + mm
}

// 时间戳转换方法    date:时间戳数字
export function format_date_ymd(date) {
  var date = new Date(date)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  return YY + MM + DD
}

// 时间戳转换方法    date:时间戳数字
export function format_datestrss(date) {
  var date = new Date(date)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
  // + ss
  return MM + DD + ' ' + hh + mm + ss
}

// 计算两个时间差 dateBegin 开始时间
export function timeFn(dateBegin) {
  // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
  var dateEnd = new Date()// 获取当前时间
  var dateDiff = dateBegin - dateEnd.getTime()// 时间差的毫秒数
  if (dateDiff <= 0) {
    return '0'
  }
  var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))// 计算出相差天数
  var leave1 = dateDiff % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000))// 计算出小时数
  // 计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))// 计算相差分钟数
  // 计算相差秒数
  var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000)

  var leave4 = leave3 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var minseconds = Math.round(leave4 / 1000)
  dayDiff = dayDiff == 0 ? '' : dayDiff + '天 '
  hours = hours == 0 ? '' : hours + '时 '
  minutes = minutes == 0 ? '' : minutes + '分'
  var timeFn = dayDiff + hours + minutes // +seconds+" 秒"+minseconds+"毫秒";
  return timeFn
}

// 计算两个时间差 dateBegin 开始时间
export function timetwo(dateend) {
  // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
  var dateEnd = new Date()// 获取当前时间
  var dateDiff = dateEnd.getTime() - dateend// 时间差的毫秒数

  console.log('dateend', dateend)
  if (dateDiff <= 0) {
    return '0'
  }
  var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))// 计算出相差天数
  var leave1 = dateDiff % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000))// 计算出小时数
  // 计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))// 计算相差分钟数
  // 计算相差秒数
  var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000)

  var leave4 = leave3 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var minseconds = Math.round(leave4 / 1000)
  dayDiff = dayDiff == 0 ? '' : dayDiff + '天 '
  hours = hours == 0 ? '' : hours + '时 '
  minutes = minutes == 0 ? '' : minutes + '分'
  var timeFn = dayDiff + hours + minutes // +seconds+" 秒"+minseconds+"毫秒";
  return timeFn
}

// 计算两个时间差 dateBegin 开始时间
export function time_cz(start_time, end_time) {
  var dateDiff = end_time - start_time// 时间差的毫秒数
  if (dateDiff <= 0) {
    return '0'
  }
  var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))// 计算出相差天数
  var leave1 = dateDiff % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000))// 计算出小时数
  // 计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))// 计算相差分钟数
  // 计算相差秒数
  var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000)

  var leave4 = leave3 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var minseconds = Math.round(leave4 / 1000)
  dayDiff = dayDiff == 0 ? '' : dayDiff + '天 '
  hours = hours == 0 ? '' : hours + '时 '
  minutes = minutes == 0 ? '' : minutes + '分'
  var timeFn = dayDiff + hours + minutes // +seconds+" 秒"+minseconds+"毫秒";
  return timeFn
}

/** 导出Excel */
export function explor_excel(header, filterData, excelData, name) {
  require.ensure([], () => {
    // that.excelData为传入的数据
    const data = formatJson(filterData, excelData)
    export_json_to_excel(header, data, name) // 导出的表格名称，根据需要自己命名
  })
}
function formatJson(filterVal, jsonData) {
  return jsonData.map((v) => filterVal.map((j) => v[j]))
}

export function generateUUID() {
  var d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() // use high-precision timer if available
  }
  var uuid = 'xxxxxxxxxxyxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(24)
  })
  return uuid
}
// 随机数字
export function randomNo(length) {
  var str = '0123456789'
  var result = ''
  for (var i = length; i > 0; --i) {
    result += str[Math.floor(Math.random() * str.length)]
  }
  return result
}

// 处理精度问题
export function signFigures(num, rank = 6) {
  if (!num) return (0)
  const sign = num / Math.abs(num)
  const number = num * sign
  const temp = rank - 1 - Math.floor(Math.log10(number))
  let ans
  if (temp > 0) {
    ans = parseFloat(number.toFixed(temp))
  } else if (temp < 0) {
    ans = Math.round(number / Math.pow(10, temp)) * temp
  } else {
    ans = Math.round(number)
  }
  return (ans * sign)
}

// 【点餐价格模板分解】
export function handlerMahuaRuleData(movieTicketSettingList, id) {
  const settingList = movieTicketSettingList.map(item => {
    return {
      // 城市、影院、影厅、电影、院线 设置为对象
      mianSetting: JSON.stringify({
        // 城市
        cityNameList: item.cityNameList,
        excludeCityNameList: item.excludeCityNameList,
        // 品牌
        brandNameList: item.brandNameList,
        excludeBrandNameList: item.excludeBrandNameList,
        // 店铺
        shopNameList: item.shopNameList,
        excludeShopNameList: item.excludeShopNameList

      }),
      // 利润区间
      minProfitAmount: item.minProfitAmount / 100,
      maxProfitAmount: item.maxProfitAmount / 100,
      // 品城卡价
      membershipPrice: id ? item.membershipPrice / 100 : item.salePrice / 100,
      salePrice: item.salePrice / 100,
      //  id
      mahuaPriceItemId: item.mahuaPriceItemId,
      originId: item.originId
    }
  })
  var mianSetObj = {}
  // 找出 mianSetting 中的重复对象
  let mianSettings = settingList.reduce((cur, next) => {
    // 不重复的
    if (!mianSetObj[next.mianSetting]) {
      mianSetObj[next.mianSetting] = true
      cur.push(next.mianSetting)
    }
    // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
    return cur
  }, [])

  // 设置值
  mianSettings = mianSettings.map(item => {
    const otherSettingData = []
    settingList.forEach(set => {
      if (item == set.mianSetting) {
        otherSettingData.push({
          // 价格区间
          minProfitAmount: set.minProfitAmount,
          maxProfitAmount: set.maxProfitAmount,
          // 品城卡价
          membershipPrice: set.membershipPrice,
          salePrice: set.salePrice,
          //  id
          mahuaPriceItemId: set.mahuaPriceItemId,
          originId: set.originId
        })
      }
    })
    return {
      mianSetting: JSON.parse(item),
      otherSettingData: otherSettingData
    }
  })
  console.log(mianSettings, 'mianSettings')
  return mianSettings
}

// 处理映票规则数据
export function handlerMovieRuleData(movieTicketSettingList, id) {
  const settingList = movieTicketSettingList.map(item => {
    return {
      // 城市、影院、影厅、电影、院线 设置为对象
      mianSetting: JSON.stringify({
        // 城市
        cityCode: item.cityCode,
        excludeCityCode: item.excludeCityCode,
        cityName: item.cityName,
        excludeCityName: item.excludeCityName,
        // 院线
        cinemaLineId: item.cinemaLineId,
        excludeCinemaLineId: item.excludeCinemaLineId,
        cinemaLineName: item.cinemaLineName,
        excludeCinemaLineName: item.excludeCinemaLineName,
        // 影院
        cinemaKeyword: item.cinemaKeyword,
        excludeCinemaKeyword: item.excludeCinemaKeyword,
        // 电影
        movieKeyword: item.movieKeyword,
        excludeMovieKeyword: item.excludeMovieKeyword,
        // 影厅
        hallKeyword: item.hallKeyword,
        excludeHallKeyword: item.excludeHallKeyword
      }),
      // 价格区间
      maxOriginPrice: item.maxOriginPrice,
      minOriginPrice: item.minOriginPrice,
      // 品城卡价
      membershipCardPrice: id ? item.membershipCardPrice : item.salePrice,

      // 自助出单价
      selfTakePrice: id ? item.selfTakePrice : item.salePrice,

      salePrice: item.salePrice,
      //  id
      movieTicketPriceItemId: item.movieTicketPriceItemId,
      originId: item.originId,
      // 排序
      priceIndex: item.priceIndex,

    }
  })
  var mianSetObj = {}
  // 找出 mianSetting 中的重复对象
  let mianSettings = settingList.reduce((cur, next) => {
    // 不重复的
    if (!mianSetObj[next.mianSetting]) {
      mianSetObj[next.mianSetting] = true
      cur.push(next.mianSetting)
    }
    // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
    return cur
  }, [])

  // 设置值
  mianSettings = mianSettings.map(item => {
    const otherSettingData = []
    settingList.forEach(set => {
      if (item == set.mianSetting) {
        otherSettingData.push({
          // 价格区间
          maxOriginPrice: set.maxOriginPrice,
          minOriginPrice: set.minOriginPrice,
          // 品城卡价
          membershipCardPrice: set.membershipCardPrice,
          minMembershipCardDiscount: set.minOriginPrice > 0 ? ((set.minOriginPrice - Math.abs(set.membershipCardPrice)) / set.minOriginPrice * 10).toFixed(2) : 0,
          maxMembershipCardDiscount: set.maxOriginPrice > 0 ? ((set.maxOriginPrice - Math.abs(set.membershipCardPrice)) / set.maxOriginPrice * 10).toFixed(2) : 0,
          // 自助出单价
          selfTakePrice: set.selfTakePrice,
          minSelfTakeDiscount: set.minOriginPrice > 0 ? ((set.minOriginPrice - Math.abs(set.selfTakePrice)) / set.minOriginPrice * 10).toFixed(2) : 0,
          maxSelfTakeDiscount: set.maxOriginPrice > 0 ? ((set.maxOriginPrice - Math.abs(set.selfTakePrice)) / set.maxOriginPrice * 10).toFixed(2) : 0,
          salePrice: set.salePrice,
          //  id
          movieTicketPriceItemId: set.movieTicketPriceItemId,
          originId: set.originId,
          // 排序
          priceIndex: set.priceIndex
        })
      }
    })
    return {
      mianSetting: JSON.parse(item),
      otherSettingData: otherSettingData
    }
  })
  console.log('mianSettings', mianSettings)

  return mianSettings
}

// 分解得到提交的数据
export function decomposeMovieRuleData(mianSettings) {
  const sub_movie_rule_data = []
  mianSettings.map(set => {
    // 循环价格的数据
    set.otherSettingData.forEach(other_set => {
      sub_movie_rule_data.push({

        // 影院
        cinemaKeyword: set.mianSetting.cinemaKeyword,
        excludeCinemaKeyword: set.mianSetting.excludeCinemaKeyword,
        // 电影
        movieKeyword: set.mianSetting.movieKeyword,
        excludeMovieKeyword: set.mianSetting.excludeMovieKeyword,
        // 影厅
        hallKeyword: set.mianSetting.hallKeyword,
        excludeHallKeyword: set.mianSetting.excludeHallKeyword,
        // 院线id
        cinemaLineId: set.mianSetting.cinemaLineId,
        excludeCinemaLineId: set.mianSetting.excludeCinemaLineId,
        // 院线名称
        cinemaLineName: set.mianSetting.cinemaLineName,
        excludeCinemaLineName: set.mianSetting.excludeCinemaLineName,
        // 城市编码
        cityCode: set.mianSetting.cityCode,
        excludeCityCode: set.mianSetting.excludeCityCode,
        // 城市名称
        cityName: set.mianSetting.cityName,
        excludeCityName: set.mianSetting.excludeCityName,

        // 价格区间
        maxOriginPrice: other_set.maxOriginPrice,
        minOriginPrice: other_set.minOriginPrice,
        // 接单价
        bidTakePrice: other_set.bidTakePrice,
        // 销售价
        salePrice: other_set.salePrice,
        // 品城卡价
        membershipCardPrice: other_set.membershipCardPrice,
        minMembershipCardDiscount: other_set.minOriginPrice > 0 ? ((other_set.minOriginPrice - other_set.membershipCardPrice) / other_set.minOriginPrice * 10).toFixed(2) : 0,
        maxMembershipCardDiscount: other_set.maxOriginPrice > 0 ? ((other_set.maxOriginPrice - other_set.membershipCardPrice) / other_set.maxOriginPrice * 10).toFixed(2) : 0,
        // 自助出单价
        selfTakePrice: other_set.selfTakePrice,
        minSelfTakeDiscount: other_set.minOriginPrice > 0 ? ((other_set.minOriginPrice - other_set.selfTakePrice) / other_set.minOriginPrice * 10).toFixed(2) : 0,
        maxSelfTakeDiscount: other_set.maxOriginPrice > 0 ? ((other_set.maxOriginPrice - other_set.selfTakePrice) / other_set.maxOriginPrice * 10).toFixed(2) : 0,
        // 其他
        movieTicketPriceItemId: other_set.movieTicketPriceItemId,
        originId: other_set.originId,
        priceIndex: other_set.priceIndex
      })
    })
  })
  return sub_movie_rule_data
}

// 【点餐】
export function decomposeMahuaRuleData(mianSettings) {
  const sub_mahua_rule_data = []
  mianSettings.map(set => {
    // 循环价格的数据
    set.otherSettingData.forEach(other_set => {
      sub_mahua_rule_data.push({
        // 城市
        cityNameList: set.mianSetting.cityNameList,
        excludeCityNameList: set.mianSetting.excludeCityNameList,
        // 品牌
        brandNameList: set.mianSetting.brandNameList,
        excludeBrandNameList: set.mianSetting.excludeBrandNameList,
        // 店铺
        shopNameList: set.mianSetting.shopNameList,
        excludeShopNameList: set.mianSetting.excludeShopNameList,
        // 价格区间
        minProfitAmount: other_set.minProfitAmount * 100,
        maxProfitAmount: other_set.maxProfitAmount * 100,
        // 销售价
        salePrice: other_set.salePrice * 100,
        // 品城卡价
        membershipPrice: other_set.membershipPrice * 100,
        // 其他
        mahuaPriceItemId: other_set.mahuaPriceItemId,
        originId: other_set.originId
      })
    })
  })
  return sub_mahua_rule_data
}


// 分解得到提交的数据[麻花点餐模板]
export function decomposeMahuaRuleData2(mianSettings) {
  console.log(mianSettings,'mianSettings')
  return mianSettings.map(set => {
    return {
      // 城市
      cityNameList: (set.cityNameList && set.cityNameList.length > 0) ? set.cityNameList.toString() : '',
      excludeCityNameList: (set.excludeCityNameList && set.excludeCityNameList.length > 0) ? set.excludeCityNameList.toString() : '',
      cityCodeList: (set.cityCodeList && set.cityCodeList.length > 0) ? set.cityCodeList.toString() : '',
      excludeCityCodeList: (set.excludeCityCodeList && set.excludeCityCodeList.length > 0) ? set.excludeCityCodeList.toString() : '',

      // 品牌
      brandCodeList: set.brandCodeList.length > 0 ? set.brandCodeList.toString() : '',
      excludeBrandCodeList: set.excludeBrandCodeList.length > 0 ? set.excludeBrandCodeList.toString() : '',
      brandNameList: set.brandNameList.length > 0 ? set.brandNameList.toString() : '',
      excludeBrandNameList: set.excludeBrandNameList.length > 0 ? set.excludeBrandNameList.toString() : '',
      // 店铺
      shopIdList: set.shopIdList.length > 0 ? set.shopIdList.toString() : '',
      shopNameList: set.shopNameList.length > 0 ? set.shopNameList.toString() : '',
      excludeShopIdList: set.excludeShopIdList.length > 0 ? set.excludeShopIdList.toString() : '',
      excludeShopNameList: set.excludeShopNameList.length > 0 ? set.excludeShopNameList.toString() : '',

      // 商品
      productMemoKeywords: set.productMemoKeywords.length > 0 ? set.productMemoKeywords.toString() : '',
      excludeProductMemoKeywords: set.excludeProductMemoKeywords.length > 0 ? set.excludeProductMemoKeywords.toString() : '',
      mahuaGoodsId: set.mahuaGoodsId.length > 0 ? set.mahuaGoodsId.toString() : '',
      goodsId: (set.goodsId && set.goodsId.length > 0) ? set.goodsId.toString() : '',

      // 规格
      productSpecKeywords: set.productSpecKeywords.length > 0 ? set.productSpecKeywords.toString() : '',
      excludeProductSpecKeywords: set.excludeProductSpecKeywords.length > 0 ? set.excludeProductSpecKeywords.toString() : '',

      // 价格区间
      maxOriginPrice: set.maxOriginPrice * 100,
      minOriginPrice: set.minOriginPrice * 100,
      //  id
      id: set.id,
    }
  })
}

// 分解得到提交的数据
export function handlerMahuaRuleData2(mianSettings) {
  return mianSettings.map(item => {
    let goodsList = []
    if(item.mahuaGoodsId){
      let ids = item.goodsId?item.goodsId.split(','):[]
      let list = item.mahuaGoodsId.split(',')
      let productSpecKeywords = item.productSpecKeywords.split(',')
      list.map((i,inx) =>{
        goodsList.push({
          thridOrginId:i,
          goodsName:productSpecKeywords[inx],
          id: ids && ids.length ?ids[inx]:'',
        })
      })
    }
    return {
      // 城市
      cityCodeList: item.cityCodeList ? item.cityCodeList.split(',') : [],
      excludeCityCodeList: item.excludeCityCodeList ? item.excludeCityCodeList.split(',') : [],
      cityNameList: item.cityNameList ? item.cityNameList.split(',') : [],
      excludeCityNameList: item.excludeCityNameList ? item.excludeCityNameList.split(',') : [],

      // cityNameListArr: item.cityNameList ? item.cityNameList.split(',') : [],
      // excludeCityNameListArr: item.excludeCityNameList ? item.excludeCityNameList.split(',') : [],

      // 品牌
      brandCodeList: item.brandCodeList ? item.brandCodeList.split(',') : [],
      excludeBrandCodeList: item.excludeBrandCodeList ? item.excludeBrandCodeList.split(',') : [],
      brandNameList: item.brandNameList ? item.brandNameList.split(',') : [],
      excludeBrandNameList: item.excludeBrandNameList ? item.excludeBrandNameList.split(',') : [],
      // brandCodeListArr: item.brandCodeList ? item.brandCodeList.split(',') : [],
      // excludeBrandCodeListArr: item.excludeBrandCodeList ? item.excludeBrandCodeList.split(',') : [],

      // 店铺
      shopIdList: item.shopIdList ? item.shopIdList.split(',') : [],
      shopNameList: item.shopNameList ? item.shopNameList.split(',') : [],
      excludeShopIdList: item.excludeShopIdList ? item.excludeShopIdList.split(',') : [],
      excludeShopNameList: item.excludeShopNameList ? item.excludeShopNameList.split(',') : [],
      // shopNameListArr: GetshopNameListArr(item.shopNameList, item.shopIdList),
      // excludeShopNameListArr: GetshopNameListArr(item.excludeShopNameList, item.excludeShopIdList),

      productMemoKeywords: item.productMemoKeywords ? item.productMemoKeywords.split(',') : [],
      mahuaGoodsId: item.mahuaGoodsId ? item.mahuaGoodsId.split(',') : [],
      goodsId: item.goodsId ? item.goodsId.split(',') : [],
      goodsList:goodsList,
      // productMemoKeywordsArr: item.productMemoKeywords ? item.productMemoKeywords.split(',') : [],
      excludeProductMemoKeywords: item.excludeProductMemoKeywords ? item.excludeProductMemoKeywords.split(',') : [],
      // excludeProductMemoKeywordsArr: item.excludeProductMemoKeywords ? item.excludeProductMemoKeywords.split(',') : [],

      productSpecKeywords: item.productSpecKeywords ? item.productSpecKeywords.split(',') : [],
      // productSpecKeywordsArr: item.productSpecKeywords ? item.productSpecKeywords.split(',') : [],
      excludeProductSpecKeywords: item.excludeProductSpecKeywords ? item.excludeProductSpecKeywords.split(',') : [],
      // excludeProductSpecKeywordsArr: item.excludeProductSpecKeywords ? item.excludeProductSpecKeywords.split(',') : [],

      // 价格区间
      maxOriginPrice: item.maxOriginPrice / 100,
      minOriginPrice: item.minOriginPrice / 100,
      //  id
      id: item.id,
    }
  })

}
//本地生活优惠券规则数据分解
export function handlerLocalRuleData(mianSettings,type) {
  console.log(mianSettings, 'mianSettingsmianSettingsmianSettings')
  let list = []
  mianSettings.map(item => {
    let cNameArr = [];
    let eNameArr = [];
    /**  包含城市 */
    if (item.includeCityNames && item.includeCityCodes) {
        let nameArr = item.includeCityNames
        let codeArr = item.includeCityCodes
        nameArr.forEach((item, index) => {
            cNameArr.push(codeArr[index] + "-" + item);
        });
    }
    /**  不包含城市 */
    if (item.excludeCityNames && item.excludeCityCodes) {
        let nameEArr = item.excludeCityNames
        let codeEArr = item.excludeCityCodes
        nameEArr.forEach((item, index) => {
            eNameArr.push(codeEArr[index] + "-" + item);
        });
    }
    item.cityNameArr = cNameArr;
    item.excludeCityNameArr = eNameArr;
    let shopKeeperList = []
    if (item.includeShopKeeperIds) {
      item.includeShopKeeperIds.map((i, inx) => {
        shopKeeperList.push({
          shopName: item.includeShopKeeperNames && item.includeShopKeeperNames.length?item.includeShopKeeperNames[inx] : '',
          shopKeeperId: i
        })
      })
    }
    let shopKeeperLists = []
    if (item.excludeShopKeeperIds) {
      item.excludeShopKeeperIds.map((i, inx) => {
        shopKeeperLists.push({
          shopName: item.excludeShopKeeperNames && item.excludeShopKeeperNames.length?item.excludeShopKeeperNames[inx] : '',
          shopKeeperId: i
        })
      })
    }
    let goodsList = []
    if (item.includeGoodsIds) {
      item.includeGoodsIds.map((i, inx) => {
        goodsList.push({
          goodsName: item.includeGoodsNames&&item.includeGoodsNames.length?item.includeGoodsNames[inx]: '',
          id: i
        })
      })
    }
    let goodsLists = []
    if (item.excludeGoodsIds) {
      item.excludeGoodsIds.map((i, inx) => {
        goodsLists.push({
          goodsName: item.excludeGoodsNames&&item.excludeGoodsNames.length?item.excludeGoodsNames[inx]: '',
          id: i
        })
      })
    }
    let packageList = []
    if (item.includeGoodsItemIds) {
      item.includeGoodsItemIds.map((i, inx) => {
        packageList.push({
          subTitle: item.includeGoodsItemNames&&item.includeGoodsItemNames?item.includeGoodsItemNames[inx]:'',
          id: i
        })
      })
    }
    let packageLists = []
    if (item.excludeGoodsItemIds) {
      item.excludeGoodsItemIds.map((i, inx) => {
        packageLists.push({
          subTitle: item.excludeGoodsItemNames&&item.excludeGoodsItemNames.length?item.excludeGoodsItemNames[inx]:'',
          id: i
        })
      })
    }
    list.push({
      // 城市
      cityNameArr:item.cityNameArr?item.cityNameArr:[],
      excludeCityNameArr:item.excludeCityNameArr?item.excludeCityNameArr:[],
      includeCityCodes: [],
      includeCityNames: [],
      excludeCityCodes: [],
      excludeCityNames: [],
      //商品类型
      goodsCategoryIds: item.goodsCategoryIds,
      //门店类型
      includeSubCategoryCodes: item.includeSubCategoryCodes?item.includeSubCategoryCodes:[],
      includeSubCategoryNames: item.includeSubCategoryNames?item.includeSubCategoryNames:[],
      excludeSubCategoryCodes: item.excludeSubCategoryCodes?item.excludeSubCategoryCodes:[],
      excludeSubCategoryNames: item.excludeSubCategoryNames?item.excludeSubCategoryNames:[],
      //商家
      includeShopKeeperIds: item.includeShopKeeperIds?item.includeShopKeeperIds:[],
      includeShopKeeperNames: item.includeShopKeeperNames?item.includeShopKeeperNames:[],
      excludeShopKeeperIds: item.excludeShopKeeperIds?item.excludeShopKeeperIds:[],
      excludeShopKeeperNames: item.excludeShopKeeperNames?item.excludeShopKeeperNames:[],
      //商品
      includeGoodsIds: type == 'string'?item.includeGoodsIds?item.includeGoodsIds[0]:'':item.includeGoodsIds?item.includeGoodsIds:[],
      includeGoodsNames: item.includeGoodsNames?item.includeGoodsNames:[],
      excludeGoodsIds: item.excludeGoodsIds?item.excludeGoodsIds:[],
      excludeGoodsNames: item.excludeGoodsNames?item.excludeGoodsNames:[],
      //套餐
      includeGoodsItemIds: type == 'string'?item.includeGoodsItemIds?item.includeGoodsItemIds[0]:'':item.includeGoodsItemIds?item.includeGoodsItemIds:[],
      includeGoodsItemNames: item.includeGoodsItemNames?item.includeGoodsItemNames:[],
      excludeGoodsItemIds: item.excludeGoodsItemIds?item.excludeGoodsItemIds:[],
      excludeGoodsItemNames: item.excludeGoodsItemNames?item.excludeGoodsItemNames:[],
      shopKeeperList: shopKeeperList,//包含商家列表
      shopKeeperLists: shopKeeperLists,//不包含商家列表
      goodsList: goodsList,//包含商品列表
      goodsLists: goodsLists,//不包含商品列表
      packageList: packageList,//包含商品对应的套餐列表
      packageLists: packageLists,//不包含商品对应的套餐列表
      maxOriginPrice: item.maxOriginPrice / 100,
      minOriginPrice: item.minOriginPrice / 100,
    })
  })
  return list;
}
// 【本地生活获取详情价格模板分解】
export function detailLocalRuleData(list, id) {
  let goodsTypeList = [
    { name: "福袋", value: "BlindBox", desc: '福袋随机商品', disabled: false },
    { name: "门店核销商品", value: "CheckCode", desc: '支持线下核销、到店自提', disabled: false },
    { name: "电商商品", value: "Goods", desc: '支持快递邮寄、同城配送', disabled: false },
    { name: "卡劵商品", value: "ECard", desc: '通过卡号卡密核销', disabled: false },
    { name: "学习视频", value: "LearnVideo", desc: '在线视频学习', disabled: false },
    { name: "外送", value: "TakeoutGoods", desc: '送货上门', disabled: false },
  ]
  let goodsCategoryNames = []
  const settingList = list.map(item => {
    return {
      mianSetting: JSON.stringify({
        //商品类型
        goodsCategoryIds: item.origin.goodsCategoryIds ? item.origin.goodsCategoryIds : [],
        //门店类型
        includeSubCategoryCodes: item.origin.includeSubCategoryCodes ? item.origin.includeSubCategoryCodes : [],
        excludeSubCategoryCodes: item.origin.excludeSubCategoryCodes ? item.origin.excludeSubCategoryCodes : [],
        includeSubCategoryNames: item.origin.includeSubCategoryNames ? item.origin.includeSubCategoryNames : [],
        excludeSubCategoryNames: item.origin.excludeSubCategoryNames ? item.origin.excludeSubCategoryNames : [],
        //商家
        includeShopKeeperIds: item.origin.includeShopKeeperIds ? item.origin.includeShopKeeperIds : [],
        excludeShopKeeperIds: item.origin.excludeShopKeeperIds ? item.origin.excludeShopKeeperIds : [],
        includeShopKeeperNames: item.origin.includeShopKeeperNames ? item.origin.includeShopKeeperNames : [],
        excludeShopKeeperNames: item.origin.excludeShopKeeperNames ? item.origin.excludeShopKeeperNames : [],
        //门店
        includeShopIds: item.origin.includeShopIds ? item.origin.includeShopIds : [],
        excludeShopIds: item.origin.excludeShopIds ? item.origin.excludeShopIds : [],
        includeShopNames: item.origin.includeShopNames ? item.origin.includeShopNames : [],
        excludeShopNames: item.origin.excludeShopNames ? item.origin.excludeShopNames : [],
        //商品
        includeGoodsIds: item.origin.includeGoodsIds ? item.origin.includeGoodsIds : [],
        includeGoodsNames: item.origin.includeGoodsNames ? item.origin.includeGoodsNames : [],
        excludeGoodsIds: item.origin.excludeGoodsIds ? item.origin.excludeGoodsIds : [],
        excludeGoodsNames: item.origin.excludeGoodsNames ? item.origin.excludeGoodsNames : [],
        //套餐
        includeGoodsItemIds: item.origin.includeGoodsItemIds ? item.origin.includeGoodsItemIds : [],
        includeGoodsItemNames: item.origin.includeGoodsItemNames ? item.origin.includeGoodsItemNames : [],
        excludeGoodsItemIds: item.origin.excludeGoodsItemIds ? item.origin.excludeGoodsItemIds : [],
        excludeGoodsItemNames: item.origin.excludeGoodsItemNames ? item.origin.excludeGoodsItemNames : [],
        localCaterPriceTemplateId: item.origin.localCaterPriceTemplateId,
      }),
      // 利润区间
      minProfitAmount: item.origin.minProfitAmount / 100,
      maxProfitAmount: item.origin.maxProfitAmount / 100,
      // 品城卡价
      membershipCardFloat: item.membershipCardFloat / 100,
      saleAmount: item.origin.saleAmount / 100,
      settleAmount: item.origin.settleAmount / 100,
      //  id
      id: item.id,
      originId: item.originId
    }
  })
  var mianSetObj = {}
  // 找出 mianSetting 中的重复对象
  let mianSettings = settingList.reduce((cur, next) => {
    // 不重复的
    if (!mianSetObj[next.mianSetting]) {
      mianSetObj[next.mianSetting] = true
      cur.push(next.mianSetting)
    }
    // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
    return cur
  }, [])

  // 设置值
  mianSettings = mianSettings.map(item => {
    const otherSettingData = []
    settingList.forEach(set => {
      if (item == set.mianSetting) {
        otherSettingData.push({
          // 价格区间
          minProfitAmount: set.minProfitAmount,
          maxProfitAmount: set.maxProfitAmount,
          // 品城卡价
          membershipCardFloat: set.membershipCardFloat,
          saleAmount: set.saleAmount,
          settleAmount: set.settleAmount,
          //  id
          localCaterPriceTemplateId: set.localCaterPriceTemplateId,
          id:set.id,
          originId: set.originId
        })
      }
    })
    return {
      mianSetting: JSON.parse(item),
      otherSettingData: otherSettingData
    }
  })
  mianSettings.map(item => {
    item.mianSetting.goodsCategoryNames = []
    if (item.mianSetting.goodsCategoryIds && item.mianSetting.goodsCategoryIds.length > 0) {
      item.mianSetting.goodsCategoryIds.map(ids => {
        goodsTypeList.map(i => {
          if (ids == i.value) {
            item.mianSetting.goodsCategoryNames.push(i.name)
          }
        })
      })
    }
  })
  console.log(mianSettings, 'mianSettings')
  return mianSettings
}
// 【本地生活提交价格模板分解】
export function decomposeLocalRuleData(mianSettings) {
  console.log(mianSettings, 'mianSettings')
  const sub_mahua_rule_data = []
  mianSettings.map(set => {
    // 循环价格的数据
    set.otherSettingData.forEach(other_set => {
      // // 价格区间
      // set.mianSetting.minProfitAmount= other_set.minProfitAmount * 100
      // set.mianSetting.maxProfitAmount= other_set.maxProfitAmount * 100
      // // 销售价
      // set.mianSetting.saleAmount= other_set.saleAmount * 100
      // set.mianSetting.settleAmount=other_set.settleAmount * 100
      sub_mahua_rule_data.push({
        origin: set.mianSetting,
        // 品城卡价
        membershipCardFloat: other_set.membershipCardFloat * 100,
        // 其他
        id: other_set.id,
        originId: other_set.originId
      })
    })
  })
  return sub_mahua_rule_data
}

// 根据code 获取到 name
function getCityCodeString(originalCityData, names) {
  let codes = [];
  names.forEach(name => {
    let city = originalCityData.find(city_obj => {
      return city_obj.cityName == name;
    });
    if (city) {
      codes.push(city.cityCode);
    }
  })
  return codes.length > 0 ? codes.toString() : '';
}

// 【品牌】根据id 获取到 name
function getBrandNameString(brands, ids) {
  let names = [];
  ids.forEach(id => {
    let brand = brands.find(line => {
      return line.code == id;
    })
    if (brand) {
      names.push(brand.name);
    }
  })
  return names.length > 0 ? names.toString() : '';
}

// 【店铺】
function getShopIdAndName(idNameArr) {
  let backData = {
    ids: [],
    names: []
  };
  (idNameArr || []).forEach(id_name => {
    let id_names = id_name.split('ぁ');
    backData.ids.push(id_names[0]);
    backData.names.push(id_names[1]);
  })
  if (backData.ids.length == 0) {
    backData.ids = '';
  }
  if (backData.names.length == 0) {
    backData.names = '';
  }
  backData.ids = backData.ids.toString();
  backData.names = backData.names.toString();
  return backData;
}


function GetshopNameListArr(shopNameList, shopIdList) {
  let idAndNameArr = [];
  /**  包含城市 */
  if (shopNameList && shopIdList) {
    let shopNameArr = shopNameList.split(",");
    let shopIdArr = shopIdList.split(",");
    shopNameArr.forEach((item, index) => {
      idAndNameArr.push(shopIdArr[index] + 'ぁ' + item);
    });
  }
  console.info('idAndNameArr', idAndNameArr)
  return idAndNameArr;

}
export function treeData(data, list) {
  for (let i of list) {
    let array = data.filter(item => {
      let code = new RegExp(i.code + "-([a-zA-Z0-9]+)$")
      return code.test(item.code);
    })
    if (array.length > 0) {
      i.children = array
      treeData(data, array)
    }
  }
  return list[0].children;
}
//城市数据格式
export function cityDatas(list) {
  console.log(list, 'list')
  let cityList = []
  list.map(item => {
      if (item.level == 'province') {
          cityList.push({
              value: item.code,
              label: item.name,
              children: []
          })
      }
  })
  list.map(item => {
      // && (i.value.substring(0, 2) == item.code.substring(0, 2)) && (i.value != item.code)
      cityList.map(i => {
          if (item.level == 'city' && (i.value.substring(0, 2) == item.code.substring(0, 2))) {
              i.children.push({
                  value: item.code,
                  label: item.name,
                  num: item.num
              })
          }
      })
  })
  return cityList;
}
//城市数据格式
export function cityData(list) {
  let cityList = []
  list.map(item => {
    if (item.level == 'province') {
      cityList.push({
        value: item.code,
        label: item.name,
        children: []
      })
    }
  })
  list.map(item => {
    cityList.map(i => {
      if (item.level == 'city' && (i.value.substring(0, 2) == item.code.substring(0, 2)) && (i.value != item.code)) {
        i.children.push({
          value: item.code,
          label: item.name,
        })
      }
    })
  })
  return cityList;
}
//城市数据格式
export function provinceData(list) {
  let cityList = []
  list.map(item => {
    if (item.level == 'province') {
      cityList.push({
        value: item.code,
        label: item.name,
      })
    }
  })
  // list.map(item => {
  //   cityList.map(i => {
  //     if (item.level == 'city' && (i.value.substring(0, 2) == item.code.substring(0, 2)) && (i.value != item.code)) {
  //       i.children.push({
  //         value: item.code,
  //         label: item.name,
  //       })
  //     }
  //   })
  // })
  return cityList;
}
export function getNextDate(date, day) {
  var dd = new Date(date);
  dd.setDate(dd.getDate() + day);
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
  var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
  return y + "-" + m + "-" + d;
}
// 导出分组数据筛选
export function getGroupList(tagList, list) {
  let myList = []
  for (let i = 0; i < tagList.length; i++) {
    myList.push([])
    list.map(item => {
      if (item.stationAgent.tags.toString().indexOf(tagList[i]) > -1) {
        myList[i].push({
          tag: tagList[i],
          ...item
        })
      }
    })
  }
  return myList
}
//获取当月的开始时间和结束时间
export function getMonthStartEnd() {
  var now = new Date(); // 获取当前日期时间
  var YY = now.getFullYear() + '-'
  var MM = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1) + '-'
  var DD = (now.getDate() < 10 ? '0' + (now.getDate()) : now.getDate())
  var monthStart = format_date_ymd(new Date(now.getFullYear(), now.getMonth(), 1));
  var monthEnd = YY + MM + DD
  return [monthStart, monthEnd]
}
//获取字符串中的两个颜色值
export function getColor(obj) {
  let color1 = ''
  let color2 = ''
  if (obj) {
    const index1 = obj.indexOf('#')
    const index2 = obj.indexOf('#', index1 + 1)
    color1 = obj.substr(index1, 7)
    color2 = obj.substr(index2, 7)
  }
  return {
    color1,
    color2
  }
}
//去8个字母数字组合
export function random(num = 8) {
  let str = ""
  let array = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  for (let i = 0; i < num; i++) {
    str +=
      array[Math.round(Math.random() * (array.length - 1))];
  }
  return str
}
//处理本地生活规则数据
export function localItemsData(list, typeList) {
  let settingList = list.map((item, index) => {
    return {
      mianSetting: JSON.stringify({
        //商家
        includeShopKeeperIds: item.shopKeeperIds ? item.shopKeeperIds : [],
        includeShopKeeperNames: item.shopKeeperNames ? item.shopKeeperNames : [],
        //商品
        includeGoodsIds: item.goodsIds ? item.goodsIds : [],
        includeGoodsNames: item.goodsNames ? item.goodsNames : [],
      }),
      // 分润比例
      profitRate: item.profitRate / 100,
      id:item.stationLcPriceTemplateItemId
    }
  });
  var mianSetObj = {};
  // 找出 mianSetting 中的重复对象
  let mianSettings = settingList.reduce((cur, next) => {
    // 不重复的
    if (!mianSetObj[next.mianSetting]) {
      mianSetObj[next.mianSetting] = true;
      cur.push(next.mianSetting)
    }
    // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
    return cur;
  }, []);

  // 设置值
  mianSettings = mianSettings.map(item => {
    let otherSettingData = [];
    settingList.forEach(set => {
      if (item == set.mianSetting) {
        otherSettingData.push({
          // 分润比例
          profitRate: set.profitRate,
          id:set.id
        })
      }
    })
    return {
      mianSetting: JSON.parse(item),
      items: otherSettingData,
    };
  })
  let lists = []
  let shopKeeperList = []
  let goodsList = []
  mianSettings.map(item => {
    if (item.mianSetting.includeShopKeeperIds) {
      item.mianSetting.includeShopKeeperIds.map((i, inx) => {
        shopKeeperList.push({
          shopName: item.mianSetting.includeShopKeeperNames[inx],
          shopKeeperId: i
        })
      })
    }
    if (item.mianSetting.includeGoodsIds) {
      item.mianSetting.includeGoodsIds.map((i, inx) => {
        goodsList.push({
          goodsName: item.mianSetting.includeGoodsNames[inx],
          id: i
        })
      })
    }
    lists.push({
      //商家
      includeShopKeeperIds: item.mianSetting.includeShopKeeperIds ? item.mianSetting.includeShopKeeperIds : [],
      includeShopKeeperNames: item.mianSetting.includeShopKeeperNames ? item.mianSetting.includeShopKeeperNames : [],
      //商品
      includeGoodsIds: item.mianSetting.includeGoodsIds ? item.mianSetting.includeGoodsIds : [],
      includeGoodsNames: item.mianSetting.includeGoodsNames ? item.mianSetting.includeGoodsNames : [],
      shopKeeperList: shopKeeperList,//包含商家列表
      goodsList: goodsList,//包含商品列表
      items: item.items,
      showSplx: false,
      showMdlx: false,
      showSj: false,
      showSp: false,
      showTc: false,
    })
  })
  return lists;
}
/**
   * 手机号中间四位为*
   */
export function InterceptPhone (phone) {
  return phone.substring(0, 3) + '****' + phone.substring(7)
}
//根据两个值计算折扣
export function getDiscount(price, prices) {
  return (price / prices * 10).toFixed(2)
}
// 解决js数字小数点丢失精度的问题
export function numMultiFn(num1, num2) {
    var baseNum = 0;
    baseNum += num1.toString().split(".")[1].length;//获取数字一小数点后的长度
    baseNum += num2.toString().split(".")[1].length;//获取数字二小数点后的长度
    return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
}


export function jdRuleData(list,id){
  let myItems = []
  list.map(item =>{
    let goodsList = []
    let items = []
    goodsList.push({
      goodsName:item.origin.includeGoodsNames.toString(),
      goodsId: item.origin.includeGoodsIds.toString()
    })
    if(id){
      items.push({
        costAmount: Number((item.costAmount/100).toFixed(2)),
        lockSettlePrice:item.lockSettlePrice,
        saleAmount: Number((item.origin.saleAmount/100).toFixed(2)),
        settleAmount: Number((item.settleAmount/100).toFixed(2)),
        subTitle:item.origin.includeGoodsItemNames.toString(),
        goodsItemId:item.origin.includeGoodsItemIds.toString(),
        originId:item.originId,
        contract: item.contract,
        id:item.id?item.id:'',
        saleAmount2: Number((item.saleAmount/100).toFixed(2)),
      })
    }else{
      items.push({
        costAmount: Number((item.origin.settleAmount/100).toFixed(2)),
        lockSettlePrice: false,
        saleAmount: Number((item.origin.saleAmount/100).toFixed(2)),
        settleAmount:'',
        subTitle:item.origin.includeGoodsItemNames.toString(),
        goodsItemId:item.origin.includeGoodsItemIds.toString(),
        originId:item.originId,
        contract: item.contract,
        id:item.id?item.id:'',
        saleAmount2: Number((item.saleAmount/100).toFixed(2)),
      })
    }
    myItems.push({
      goodsList,
      items,
    })
  })
  var mianSetObj = {}
  // 找出 mianSetting 中的重复对象
  let mianSettings = myItems.reduce((cur, next) => {
    // 不重复的
    if (!mianSetObj[next.goodsList[0].goodsId]) {
      mianSetObj[next.goodsList[0].goodsId] = true
      cur.push(next.goodsList[0].goodsId)
    }
    // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
    return cur
  }, [])
  mianSettings = mianSettings.map(item => {
    let items1 = []
    let goodsList1 = []
    myItems.map((set) => {
      if (item == set.goodsList[0].goodsId) {
        goodsList1 = set.goodsList
        items1.push({
          costAmount: set.items[0].costAmount,
          lockSettlePrice:set.items[0].lockSettlePrice,
          saleAmount: set.items[0].saleAmount,
          settleAmount: set.items[0].settleAmount,
          subTitle: set.items[0].subTitle,
          originId: set.items[0].originId,
          goodsItemId: set.items[0].goodsItemId,
          contract: set.items[0].contract,
          saleAmount2: set.items[0].saleAmount2,
          id:set.items[0].id,
        })
      }
    })
    return {
      goodsList: goodsList1,
      items: items1
    }
  })
  console.log(mianSettings,'mianSettings')
  return mianSettings
}
export function ruleCityName(cities,list){
  let array = []
  list.map(item =>{
      array.push({
          includeCityCodes: item.includeCityCodes,
          includeCityNames: getCityName(cities, item.includeCityCodes),
          costAmount: item.costAmount * 100,
          saleAmount: item.saleAmount * 100,
          settleAmount: item.settleAmount * 100,
          goodsId:item.goodsId,
          goodsItemId:item.goodsItemId,
          id:item.id?item.id:null,
      })
  })
  return array
}

// 分解得到提交的数据
export function ksPriceRuleData(cities, lines, mianSettings) {
    let sub_movie_rule_data = [];
    mianSettings.map(set => {
        // 循环价格的数据
        set.otherSettingData.forEach(other_set => {
            sub_movie_rule_data.push({
                // 城市
                cityName: set.mianSetting.cityNameArr.length > 0 ? set.mianSetting.cityNameArr.toString() : '',
                excludeCityName: set.mianSetting.excludeCityNameArr.length > 0 ? set.mianSetting.excludeCityNameArr.toString() : '',

                cityCode: getCityCodeString(cities, set.mianSetting.cityNameArr),
                excludeCityCode: getCityNameString(cities, set.mianSetting.excludeCityNameArr),

                // 院线
                cinemaLineId: set.mianSetting.cinemaLineIdArr.length > 0 ? set.mianSetting.cinemaLineIdArr.toString() : '',
                excludeCinemaLineId: set.mianSetting.excludeCinemaLineIdArr.length > 0 ? set.mianSetting.excludeCinemaLineIdArr.toString() : '',
                cinemaLineName: getLineNameString(lines, set.mianSetting.cinemaLineIdArr),
                excludeCinemaLineName: getLineNameString(lines, set.mianSetting.excludeCinemaLineIdArr),

                // 影院
                cinemaKeyword: set.mianSetting.cinemaKeywordArr.length > 0 ? set.mianSetting.cinemaKeywordArr.toString() : '',
                excludeCinemaKeyword: set.mianSetting.excludeCinemaKeywordArr.length > 0 ? set.mianSetting.excludeCinemaKeywordArr.toString() : '',

                // 电影
                movieKeyword: set.mianSetting.movieKeywordArr && set.mianSetting.movieKeywordArr.length > 0 ? set.mianSetting.movieKeywordArr.toString() : '',
                excludeMovieKeyword: set.mianSetting.excludeMovieKeyword && set.mianSetting.excludeMovieKeyword.length > 0 ? set.mianSetting.excludeMovieKeyword.toString() : '',

                // 影厅
                hallKeyword: set.mianSetting.hallKeywordArr && set.mianSetting.hallKeywordArr.length > 0 ? set.mianSetting.hallKeywordArr.toString() : '',
                excludeHallKeyword: set.mianSetting.excludeHallKeywordArr && set.mianSetting.excludeHallKeywordArr.length > 0 ? set.mianSetting.excludeHallKeywordArr.toString() : '',

                // 价格区间
                maxOriginPrice: other_set.maxOriginPrice*100,
                minOriginPrice: other_set.minOriginPrice*100,
                originPriceFloat: other_set.channelSalePrice*100,
                // 接单价
                bidTakePrice: other_set.bidTakePrice,
                //  id
                id: other_set.id,
                // 排序
                priceIndex: other_set.priceIndex,
            })
        })
    })
    return sub_movie_rule_data;
}
// 根据code 获取到 name
function getCityNameString(originalCityData, codes) {
    let names = [];
    codes.forEach(code => {
        let city = originalCityData.find(city_obj => {
            return city_obj.cityCode == code;
        });
        if (city) {
            names.push(city.cityName);
        }
    })
    return names.length > 0 ? names.toString() : '';
}
// [院线]根据id 获取到 name
function getLineNameString(lineData, ids) {
    let names = [];
    ids.forEach(id => {
        let line_obj = lineData.find(line => {
            return line.id == id;
        })
        if (line_obj) {
            names.push(line_obj.name);
        }
    })
    return names.length > 0 ? names.toString() : '';
}
// 处理影票规则数据
export function handlerksPriceRuleData(settingData, id) {
    let settingList = settingData.map((itemData, index) => {
      let item = itemData.movieTicketSettings
        return {
            // 城市、影院、影厅、电影、院线 设置为对象
            mianSetting: JSON.stringify({
                // 城市
                cityCode: item.cityCode,
                excludeCityCode: item.excludeCityCode,
                cityName: item.cityName,
                excludeCityName: item.excludeCityName,

                cityNameArr: item.cityName ? item.cityName.split(',') : [],
                excludeCityNameArr: item.excludeCityName ? item.excludeCityName.split(',') : [],
                cityCodeArr: item.cityName ? item.cityCode.split(',') : [],
                excludeCityCodeArr: item.excludeCityCode ? item.excludeCityCode.split(',') : [],

                // 院线
                cinemaLineId: item.cinemaLineId,
                excludeCinemaLineId: item.excludeCinemaLineId,
                cinemaLineName: item.cinemaLineName,
                excludeCinemaLineName: item.excludeCinemaLineName,
                cinemaLineIdArr: item.cinemaLineId ? item.cinemaLineId.split(',') : [],
                excludeCinemaLineIdArr: item.excludeCinemaLineId ? item.excludeCinemaLineId.split(',') : [],

                // 影院
                cinemaKeyword: item.cinemaKeyword,
                excludeCinemaKeyword: item.excludeCinemaKeyword,
                cinemaKeywordArr: item.cinemaKeyword ? item.cinemaKeyword.split(',') : [],
                excludeCinemaKeywordArr: item.excludeCinemaKeyword ? item.excludeCinemaKeyword.split(',') : [],

                // 电影
                movieKeyword: item.movieKeyword,
                excludeMovieKeyword: item.excludeMovieKeyword,
                movieKeywordArr: item.movieKeyword ? item.movieKeyword.split(',') : [],
                excludeMovieKeywordArr: item.excludeMovieKeyword ? item.excludeMovieKeyword.split(',') : [],

                // 影厅
                hallKeyword: item.hallKeyword,
                excludeHallKeyword: item.excludeHallKeyword,
                hallKeywordArr: item.hallKeyword ? item.hallKeyword.split(',') : [],
                excludeHallKeywordArr: item.excludeHallKeyword ? item.excludeHallKeyword.split(',') : [],

                // showCity: false,
                // showBrand: false,
                // showShop: false,
                showCity: false,
                showLine: false,
                showCinema: false,
                showMovie: false,
                showHall: false,
            }),
            // 价格区间
            maxOriginPrice: item.maxOriginPrice,
            minOriginPrice: item.minOriginPrice,
            //  id
            id: item.id,
            // 排序
            priceIndex: item.priceIndex,
            // 接单价
            bidTakePrice: item.bidTakePrice,
            // 销售价
            channelSalePrice: itemData.originPriceFloat/100,
        }
    });
    var mianSetObj = {};
    // 找出 mianSetting 中的重复对象
    let mianSettings = settingList.reduce((cur, next) => {
        // 不重复的
        if (!mianSetObj[next.mianSetting]) {
            mianSetObj[next.mianSetting] = true;
            cur.push(next.mianSetting)
        }
        // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
        return cur;
    }, []);

    // 设置值
    mianSettings = mianSettings.map(item => {
        let otherSettingData = [];
        settingList.forEach(set => {
            if (item == set.mianSetting) {
                otherSettingData.push({
                    // 价格区间
                    maxOriginPrice: set.maxOriginPrice,
                    minOriginPrice: set.minOriginPrice,
                    // 接单价
                    bidTakePrice: set.bidTakePrice,
                    minBidTakeDiscount: set.minOriginPrice > 0 ? ((set.minOriginPrice - Math.abs(set.bidTakePrice)) / set.minOriginPrice * 10).toFixed(2) : 0,
                    maxBidTakeDiscount: set.maxOriginPrice > 0 ? ((set.maxOriginPrice - Math.abs(set.bidTakePrice)) / set.maxOriginPrice * 10).toFixed(2) : 0,
                    // 销售价
                    channelSalePrice: set.channelSalePrice,
                    minSaleDiscount: set.minOriginPrice > 0 ? ((set.minOriginPrice - Math.abs(set.channelSalePrice)) / set.minOriginPrice * 10).toFixed(2) : 0,
                    maxSaleDiscount: set.maxOriginPrice > 0 ? ((set.maxOriginPrice - Math.abs(set.channelSalePrice)) / set.maxOriginPrice * 10).toFixed(2) : 0,
                    //  id
                    id: set.id,
                    // 排序
                    priceIndex: set.priceIndex,
                })
            }
        })
        return {
            mianSetting: JSON.parse(item),
            otherSettingData: otherSettingData,
        };
    })
    console.log(mianSettings)
    return mianSettings;
}